/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { applyMiddleware, createStore } from 'redux';

import createSagaMiddleware from 'redux-saga';

import { persistStore } from 'redux-persist';

import { persistedReducer } from './persist';
import { saga } from './saga';

export const configureStore = () => {
  const sagaMiddleware = createSagaMiddleware();

  const middlewares = [sagaMiddleware];
  const store = createStore(persistedReducer, applyMiddleware(...middlewares));
  sagaMiddleware.run(saga);

  const persistor = persistStore(store);

  return { store, persistor };
};

export default configureStore;
